"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationEnum = void 0;
var RecommendationEnum;
(function (RecommendationEnum) {
    RecommendationEnum[RecommendationEnum["FINE"] = 0] = "FINE";
    RecommendationEnum[RecommendationEnum["BLACK_LIST"] = 1] = "BLACK_LIST";
})(RecommendationEnum || (exports.RecommendationEnum = RecommendationEnum = {}));
